import api, { createApiService } from "../http";
import { ISettings } from "../types/services-types/admin-types";

export default class AdminService {

    static apiAdminService = createApiService('/admin')

    static async GetSettingsSite() {
        const response = await this.apiAdminService.get<ISettings>('/settings')
        return response.data
    }

    static async GethtmlTemplateBillDocument() {
        const response = await this.apiAdminService.get(`/bill-template-document-html`, {
            responseType: 'blob'
        })
        return response.data
    }

    static async ChangeSettingsSite(fee: string, name_site_currency: string, name_site: string) {
        const response = await this.apiAdminService.post('/change-settings', {
            fee,
            name_site_currency,
            name_site
        })
        return response.data
    }

    static async ChangeFaviconIco(formData: FormData) {
        const response = await this.apiAdminService.post(`/change-favicon`, formData)
        return response.data
    }

    static async ChangeBackgroundImage(formData: FormData) {
        const response = await this.apiAdminService.post(`/change-background`, formData)
        return response.data
    }

    static async SetStatusContractUser(user_id: number, status: string, message = '') {
        const response = await this.apiAdminService.post(`/set-status-contract`, {
            user_id,
            status,
            message
        })
        return response.data
    }

    static async SetStatusKycUser(user_id: number, status: boolean) {
        const response = await this.apiAdminService.post(`/set-status-kyc`, {
            user_id
        })
        return response.data
    }

    static async ChangeContractJoiningService(formData: FormData) {
        const response = await this.apiAdminService.post(`/change-contract-joining-service`, formData)
        return response.data
    }

    static async ChangeBillDocument(formData) {
        const response = await this.apiAdminService.post(`/change-bill-document`, formData)
        return response.data
    }
}